/** [本番用] ニュース欄掲載用のグループID */
export const PRODUCTION_NEWS_GROUP_ID = "65684ba53bb3434702e848f8" as const
/** [local,dev用] ニュース欄掲載用のグループID */
export const DEV_NEWS_GROUP_ID = "6541d54fa3858eec8ee63c9a" as const

/** 人気の商品カルーセル表示用の商品ID */
export const POPULAR_PRODUCT_IDS = [
  "67ca6adcce9a365145b38d0c", // BAKUNE Dry Men's 上下セット 半袖
  "67ca7b8ace9a365145b4d9a7", // BAKUNE Dry Women's 上下セット 半袖
  "67ca81df374cd6ea01be9ccb", // BAKUNE Dry Women's チュニック
  "67bed5ea46cc55e963fefea2", // BAKUNE Comforter Cool 夏用肌掛け布団
  "67bedac346cc55e963ff2281", // BAKUNE Bed Pad Cool 夏用敷きパッド
]
/** BAKUNEカルーセル表示用の商品ID */
export const RECOVERY_WEAR_PRODUCT_IDS = [
  "67ca6adcce9a365145b38d0c", // BAKUNE Dry Men's 上下セット（半袖Tシャツ・ショートパンツ）
  "67ca7b8ace9a365145b4d9a7", // BAKUNE Dry Women's 上下セット（半袖Tシャツ・ショートパンツ）
  "67cab019e7a68f2ca56d09ce", // BAKUNE 3D Dry Men's 上下セット（半袖Tシャツ・ショートパンツ）
  "67cab42be7a68f2ca56d98be", // BAKUNE 3D Dry Women's 上下セット（半袖Tシャツ・ショートパンツ）
  "67caba3fe7a68f2ca56ded57", // BAKUNE Mesh 上下セット（半袖Tシャツ・ショートパンツ）
  "67cac0b5e7a68f2ca56e32d5", // BAKUNE Pajamas Dry 上下セット（半袖シャツ・ショートパンツ）
  "67cac76de7a68f2ca56ef736", // BAKUNE Pile 上下セット（半袖Tシャツ・ショートパンツ）
  "67cacfaae7a68f2ca56fa0e5", // BAKUNE Waffle Men's 上下セット（半袖シャツ・ショートパンツ）
  "67cad93ee7a68f2ca57054cb", // BAKUNE Waffle Women's 上下セット（半袖シャツ・ショートパンツ）
]
/** MIGARUカルーセル表示用の商品ID */
export const COMFORT_TECH_WEAR_PRODUCT_IDS = [
  "67ca6725ce9a365145b2d943", // MIGARU Light Knit Short Sleeve Polo Shirt（上下セット）半袖ポロシャツ・ショートパンツ
  "67ca4b5fce9a365145af0fd7", // MIGARU Dry Women’s Tunic
  "67ca6964ce9a365145b35a61", // MIGARU Light Knit Short Sleeve T-Shirt（上下セット）半袖Tシャツ・ショートパンツ
  "67ca5883ce9a365145b0cb36", // MIGARU Light Knit Women's Short Sleeve T-Shirt（上下セット）半袖シャツ・ロングパンツ
  "67bd50c2cbab11c78b4ffcc1", // MIGARU Tech Sweat Pullover Hoodie（上下セット）
]

/** 寝具カルーセル表示用の商品ID */
export const BEDDING_PRODUCT_IDS = [
  "67bed5ea46cc55e963fefea2", // Comforter Cool
  "67bee76046cc55e963ffcdd1", // Comforter Organic Cotton Cool
  "67bedac346cc55e963ff2281", // Bed Pad Cool
  "67bee8b646cc55e963ffea1f", // Bed Pad Organic Cotton Cool
  "66960f7f3f513e5f6128ae8b", // Comforter All Seasons
]
/** サンダルカルーセル表示用の商品ID */
export const SANDAL_PRODUCT_IDS = [
  "67a3241473eead61841a241e", // Recovery Sandal Slide
  "67ca41efce9a365145ada90b", // Recovery Sandal Flip flop
  "67ca40d3ce9a365145ad7b18", // Recovery Sandal Strap
  "67ca3fe9ce9a365145ad5f80", // Recovery Sandal Slide Slide Big Logo
  "66d55b33bfcf79b7ab4df83e", // Recovery Sandal Warm
]
